import lifecycle from 'page-lifecycle';
import { selectCurrentPagePath } from '../../ReduxStorage/Pages/selectors';
import { selectCurrentCoursePath } from '../../ReduxStorage/Courses/selectors';

const makeSaveMetric = ({ saveMetric }) => (dispatch, getState) => {
  saveMetric(
    selectCurrentCoursePath(getState()),
    selectCurrentPagePath(getState())
  );
};

const INACTIVE_STATES = ['terminated', 'frozen', 'hidden'];
const ACTIVE_STATES = ['passive', 'active'];

export const startPulseMetric = ({ trigger, startPulse }) => (dispatch) => {
  dispatch(startPulse(trigger));
};

export const pausePulseMetric = ({ trigger, pausePulse }) => (dispatch) => {
  dispatch(pausePulse(trigger));
};

export const makeMetricsPageLoad = ({ metrics, resetMetrics }) => (
  dispatch
) => {
  dispatch(metrics.init());
  resetMetrics();
  if (ACTIVE_STATES.includes(lifecycle.state)) {
    dispatch(metrics.pageLoad());
  }
};

export const makeMetricsPageLeave = ({ metrics, saveMetric }) => (dispatch) => {
  if (ACTIVE_STATES.includes(lifecycle.state)) {
    dispatch(metrics.pageLeave());
    dispatch(makeSaveMetric({ saveMetric }));
  }
};

export const makeMetricsInit = ({
  metrics,
  saveMetric,
  resetMetrics,
  startPulse,
  pausePulse,
}) => (dispatch) => {
  // Initial page load
  dispatch(makeMetricsPageLoad({ metrics, resetMetrics }));

  lifecycle.addEventListener('statechange', ({ oldState, newState }) => {
    if (
      INACTIVE_STATES.indexOf(oldState) !== -1 &&
      ACTIVE_STATES.indexOf(newState) !== -1
    ) {
      // Inactive page becoming active again
      dispatch(makeMetricsPageLoad({ metrics, resetMetrics }));
    }

    if (
      ACTIVE_STATES.indexOf(oldState) !== -1 &&
      INACTIVE_STATES.indexOf(newState) !== -1
    ) {
      // Active page becoming inactive
      dispatch(metrics.pageLeave());
      dispatch(makeSaveMetric({ saveMetric }));
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      dispatch(pausePulseMetric({ trigger: 'vis', pausePulse }));
    } else {
      dispatch(startPulseMetric({ trigger: 'vis', startPulse }));
    }
  });
};
